import React, { useState } from 'react';
import Link from '../../../../../assets/link.svg';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import { Box, IconButton, Input, InputAdornment } from '@coolblue-development/freddy';

const LinkInputForm = (): JSX.Element => {
  const [editor] = useLexicalComposerContext();
  const [linkValue, setLinkValue] = useState('');

  const linkToText = (): void => {
    editor.dispatchCommand(TOGGLE_LINK_COMMAND, { url: linkValue });
  };

  return (
    <Box>
      <Input
        onChange={(event): void => {
          setLinkValue(event.target.value);
        }}
        value={linkValue}
        sx={{
          marginLeft: '10px',
          height: '30px',
          width: '300px'
        }}
        endAdornment={
          linkValue.length > 0 && (
            <InputAdornment>
              <IconButton sx={{ width: '30px' }} type="button" onClick={linkToText} variant="transparent">
                <Link />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </Box>
  );
};

export default LinkInputForm;
